
import React from 'react';
import Picker from 'emoji-picker-react';

const IconPicker = ({ onChange, onClose }) => {
    const onEmojiClick = (emojiObject, event) => {
        onChange(emojiObject.emoji);
        onClose();
    };

    return (
        <div>
            <Picker onEmojiClick={onEmojiClick} />
        </div>
    );
};

export default IconPicker;
